var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TxRendererScreenshotArea',[_c('StudentPosterLoader',[_c('StudentPoster'),_c('StudentPosterTitle')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }